@if (resourceRemovalNotifications().length > 0) {
  <div class="resource-notification-layer">
    <div class="resource-removal-notifications">
      @for (notification of resourceRemovalNotifications(); track notification.id) {
        <div
          class="resource-removal-notification"
          [class.resource-removal-notification-multiple]="notification.resourceDetails.length > 1"
          role="status"
        >
          <div class="resource-removal-notification-header">
            <span class="resource-removal-notification-icon" aria-hidden="true">!</span>
            <p>
              @if (notification.confirmation) {
                {{
                  notification.messageKey
                    | transloco: { resource: notification.resources, resources: notification.resources }
                }}
              } @else if (notification.resourceDetails.length > 1) {
                {{ translation.outlookAddin.resourcesRemovedFromEvent | transloco }}
              } @else {
                {{ notification.messageKey | transloco: { resources: notification.resources } }}
              }
            </p>
            @if (!notification.confirmation) {
              <button
                class="resource-removal-notification-close"
                (click)="closeResourceRemovalNotification(notification.id)"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            }
          </div>
          <div class="resource-removal-notification-details">
            @for (
              notificationResource of notification.resourceDetails;
              track notificationResource.resource.resourceId
            ) {
              <div class="resource-removal-notification-resource">
                @if (notification.resourceDetails.length > 1) {
                  <p class="resource-removal-notification-resource-name">{{ notificationResource.displayName }}</p>
                }
                <addin-resource-availability
                  [isRestrictedResource]="notificationResource.resource.isAssignedTo === resourceAssignType.Restricted"
                  [unavailabilityReason]="notificationResource.resource.unavailabilityReason"
                  [unavailabilityReasonValue]="notificationResource.resource.unavailabilityReasonValue"
                  [timeline]="notificationResource.resource.timeLine"
                  [startDate]="notification.start"
                  [endDate]="notification.end"
                >
                </addin-resource-availability>
              </div>
            }
          </div>
          @if (notification.confirmation) {
            <div class="resource-notification-actions">
              <button class="small secondary" (click)="cancelResourceRemovalNotification(notification.id)">
                {{ notification.confirmation.secondaryLabelKey ?? translation.outlookAddin.confirmationNo | transloco }}
              </button>
              <button class="small primary" (click)="confirmResourceRemovalNotification(notification.id)">
                {{ notification.confirmation.primaryLabelKey ?? translation.outlookAddin.confirmationYes | transloco }}
              </button>
            </div>
          }
          <div
            class="notification-countdown notification-countdown-warning"
            [class.notification-countdown-even]="notification.id % 2 === 0"
            [class.notification-countdown-odd]="notification.id % 2 !== 0"
            [style.--notification-timeout-ms]="notification.timeoutMs + 'ms'"
            aria-hidden="true"
          ></div>
        </div>
      }
    </div>
  </div>
}
@if (dataPack$ | async; as pack) {
  @if (pack.error) {
    {{ translation.outlookAddin.errorDescription | transloco }}
    <button (click)="refresh()" class="small">
      <cue-icon [icon]="ICONS.cueRefresh"></cue-icon>
      {{ translation.outlookAddin.refresh | transloco }}
    </button>
  }
  @if (!pack.error) {
    @if (pack.data; as reservationDetail) {
      <div class="mobile-ui">
        <div class="name">
          @if (reservationDetail.subject) {
            <h2>{{ reservationDetail.subject }}</h2>
          } @else {
            <h2 class="no-subject">
              {{ translation.outlookAddin.noSubject | transloco }}
            </h2>
          }
          <ng-template #noSubject>
            <h2 class="no-subject">
              {{ translation.outlookAddin.noSubject | transloco }}
            </h2>
          </ng-template>

          @switch (reservationDetail.eventState) {
            @case (eventStateEnum.Finish) {
              <span class="accepted">{{ translation.common.finished | transloco }}</span>
            }
            @case (eventStateEnum.Cancelled) {
              <span class="canceled">{{ translation.common.cancelled | transloco }}</span>
            }
          }
        </div>
        <div class="tabs-container">
          <div class="tabs">
            <div class="tab-item" [class.active]="activeTabIndex === 0" #tab (click)="setActiveTab(0)">
              <span>{{ translation.outlookAddin.locationDetail | transloco }}</span>
            </div>
            <div
              class="tab-item"
              [class.active]="activeTabIndex === 1"
              [class.disabled]="reservationDetail?.orders?.length === 0"
              #tab
              (click)="setActiveTab(1)"
            >
              <span>{{ translation.outlookAddin.orders | transloco }} ({{ reservationDetail?.orders?.length }})</span>
            </div>
          </div>
          <div
            class="tabs-slider"
            [ngStyle]="{
              width: hrStyle().width + 'px',
              transform: 'translateX(' + hrStyle().left + 'px)',
            }"
          ></div>
        </div>

        <div class="slides" #slider [class.disabled]="reservationDetail?.orders?.length === 0">
          <div class="slide" #slide>
            @if (getVisibleResources(reservationDetail.resources); as visibleResources) {
              @if (visibleResources.length > 0) {
                <addin-location-detail
                  [start]="reservationDetail.start"
                  [end]="reservationDetail.end"
                  [resourceList]="visibleResources"
                ></addin-location-detail>
              } @else {
                <div class="not-found location-detail-empty">
                  {{ translation.outlookAddin.noResourceOnEvent | transloco }}
                </div>
              }
            }
          </div>
          <div class="slide" #slide>
            <addin-order-detail [orderList]="reservationDetail.orders"> </addin-order-detail>
          </div>
        </div>
      </div>
    } @else {
      <div class="not-found">
        <cue-icon [icon]="ICONS.cueClose"></cue-icon>
        {{ translation.outlookAddin.noResourceOnEvent | transloco }}
      </div>
    }
  }
}
